module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-8055ae40.png";